import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "onboarding_hints_dismissed";
const EVENT_NAME = "onboarding-hint-changed";

function getState() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

export function useOnboardingHints() {
  const [dismissed, setDismissed] = useState(getState);

  useEffect(() => {
    const sync = () => setDismissed(getState());
    window.addEventListener(EVENT_NAME, sync);
    return () => window.removeEventListener(EVENT_NAME, sync);
  }, []);

  const dismiss = useCallback((key) => {
    const next = { ...getState(), [key]: true };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setDismissed(next);
    window.dispatchEvent(new Event(EVENT_NAME));
  }, []);

  const isNew = useCallback((key) => !dismissed[key], [dismissed]);

  return { dismiss, isNew };
}
